module.exports = __webpack_public_path__ + "img/thunderstorm.6f9ce1cb.svg";